import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["numberInput", "submitButton", "form"]

  connect() {
    this.toggleSubmit()
  }

  checkInputs() {
    const allFilled = this.numberInputTargets.every(input => !isNaN(input.valueAsNumber))
    this.submitButtonTarget.disabled = !allFilled

    if (!allFilled) {
      this.formTarget.addEventListener("submit", this.preventSubmit)
    } else {
      this.formTarget.removeEventListener("submit", this.preventSubmit)
    }
  }

  preventSubmit(event) {
    event.preventDefault()
    return false
  }

  showLoading() {
    const loadingScreen = document.getElementById("loading-screen")
    if (loadingScreen) loadingScreen.classList.remove("d-none")
  }

  toggleSubmit() {
    this.checkInputs()
  }
}

